import { T } from '@qapline/translations';
import { z } from 'zod';

const dispatcherVehicleFeatureSchema = z.object({
    vehicleFeature_id: z.number(),
    dispatcherVehicleFeature_id: z.number().optional(),
});

const dispatcherVehicleSchema = z.object({
    dispatcherVehicle_id: z.number().nullish(),
    vehicleType_id: z.number(),
    maxHeight: z.number(),
    maxWidth: z.number(),
    maxLength: z.number(),
    maxWeight: z.number(),
    vehicleFeatures: z.array(dispatcherVehicleFeatureSchema),
    dispatcher_id: z.number().nullish(),
});

const dispatcherPlaceSchema = z.object({
    place_id: z.number().nullish(),
    dispatcher_id: z.number().nullish(),
    carrier_id: z.number().nullish(),
    countryCode: z.string(),
    city: z.string(),
    postalCode: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    directionLoading: z.boolean(),
    directionDischarge: z.boolean(),
    note: z.string().nullable(),
});

export const carrierBasicFormSchema = (t: T) =>
    z.object({
        carrier_id: z.number().optional(),
        company: z
            .string({
                invalid_type_error: t('form.errors.stringFormat'),
                required_error: t('form.errors.required'),
            })
            .min(2, { message: t('form.errors.required') }),
        countryCode: z.string().min(1),
        postalCode: z
            .string({
                invalid_type_error: t('form.errors.stringFormat'),
                required_error: t('form.errors.required'),
            })
            .min(1, { message: t('form.errors.required') }),
        city: z
            .string({
                invalid_type_error: t('form.errors.stringFormat'),
                required_error: t('form.errors.required'),
            })
            .min(1, { message: t('form.errors.required') }),
        street: z
            .string({
                invalid_type_error: t('form.errors.stringFormat'),
                required_error: t('form.errors.required'),
            })
            .min(1, { message: t('form.errors.required') }),
        companyRegistrationNumber: z
            .union([
                z
                    .string({
                        invalid_type_error: t('form.errors.stringFormat'),
                    })
                    .min(8, { message: t('form.errors.minLengthOther', { minLength: 8 }) }),
                z.string().length(0),
            ])
            .nullable(),
        taxId: z
            .string({
                invalid_type_error: t('form.errors.stringFormat'),
            })
            .nullish(),
        note: z
            .string()
            // .min(2, { message: t('form.errors.minLengthFew', { minLength: 2 }) })
            .optional()
            .or(z.literal(''))
            .nullable(),
        longitude: z.number().nullable(),
        latitude: z.number().nullable(),

        dispatchers: z
            .object({
                dispatcher_id: z.number().optional(),
                carrier_id: z.number().optional(),
                name: z.string().min(1),
                surname: z.string().min(1),
                email: z.string().email(),
                contactEmail: z.string().email(),
                phone: z.string().nullable(),
                language_id: z.number().optional(),
                vehicles: dispatcherVehicleSchema.array(),
                places: dispatcherPlaceSchema.array(),
            })
            .array(),
    });
export type CarrierBasicFormSchema = z.infer<ReturnType<typeof carrierBasicFormSchema>>;
